// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.case-studies {
  background-color: white;
  perspective: 1000px;
}

.flipbook-section {
  opacity: 0;
  transform: rotateY(-15deg) translateZ(-100px);
  transform-style: preserve-3d;
  transition: all 1s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

.flipbook-section.flipbook-visible {
  opacity: 1;
  transform: rotateY(0deg) translateZ(0);
}

.case-studies-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(450px, 1fr));
  gap: 3rem;
  margin-top: 3rem;
  max-width: 1400px;
  margin-left: auto;
  margin-right: auto;
}

.case-study-card {
  background: linear-gradient(135deg, #ffffff 0%, #fafafa 100%);
  padding: 0;
  border-radius: 16px;
  border: 3px solid #ffbb00;
  box-shadow: 0 6px 25px rgba(0, 0, 0, 0.12);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.case-study-image {
  width: 100%;
  height: 320px;
  overflow: hidden;
  background: linear-gradient(135deg, #f0f0f0 0%, #e0e0e0 100%);
  position: relative;
}

.case-study-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: transform 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.case-study-card:hover .case-study-image img {
  transform: scale(1.15);
}

.case-study-content {
  padding: 2rem 2.5rem;
  display: flex;
  flex-direction: column;
  flex: 1;
}

.case-study-card:hover {
  transform: translateY(-10px) scale(1.02);
  border-color: #cc9900;
  box-shadow: 0 15px 40px rgba(255, 187, 0, 0.3);
}

.case-study-category {
  font-size: 0.95rem;
  font-weight: 700;
  color: #ffbb00;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  margin-bottom: 1rem;
  text-shadow: 0 1px 2px rgba(255, 187, 0, 0.2);
}

.case-study-card h3 {
  font-size: 2rem;
  font-weight: 900;
  margin-bottom: 1rem;
  color: #000;
  text-transform: uppercase;
  letter-spacing: -0.5px;
  line-height: 1.2;
}

.case-study-card p {
  color: #333;
  line-height: 1.8;
  margin-bottom: 2rem;
  font-size: 1.05rem;
  flex: 1;
}

.case-study-actions {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  margin-top: auto;
}

@media (max-width: 768px) {
  .case-studies-grid {
    grid-template-columns: 1fr;
  }

  .case-study-actions {
    flex-direction: column;
  }

  .case-study-actions .btn {
    width: 100%;
  }
}


`, "",{"version":3,"sources":["webpack://./src/pages/frontpage/components/CaseStudies.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,6CAA6C;EAC7C,4BAA4B;EAC5B,yDAAyD;AAC3D;;AAEA;EACE,UAAU;EACV,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,UAAU;EACV,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;EAC1C,4DAA4D;EAC5D,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kEAAkE;AACpE;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,OAAO;AACT;;AAEA;EACE,wCAAwC;EACxC,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".case-studies {\n  background-color: white;\n  perspective: 1000px;\n}\n\n.flipbook-section {\n  opacity: 0;\n  transform: rotateY(-15deg) translateZ(-100px);\n  transform-style: preserve-3d;\n  transition: all 1s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n}\n\n.flipbook-section.flipbook-visible {\n  opacity: 1;\n  transform: rotateY(0deg) translateZ(0);\n}\n\n.case-studies-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(450px, 1fr));\n  gap: 3rem;\n  margin-top: 3rem;\n  max-width: 1400px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.case-study-card {\n  background: linear-gradient(135deg, #ffffff 0%, #fafafa 100%);\n  padding: 0;\n  border-radius: 16px;\n  border: 3px solid #ffbb00;\n  box-shadow: 0 6px 25px rgba(0, 0, 0, 0.12);\n  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.case-study-image {\n  width: 100%;\n  height: 320px;\n  overflow: hidden;\n  background: linear-gradient(135deg, #f0f0f0 0%, #e0e0e0 100%);\n  position: relative;\n}\n\n.case-study-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  transition: transform 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n}\n\n.case-study-card:hover .case-study-image img {\n  transform: scale(1.15);\n}\n\n.case-study-content {\n  padding: 2rem 2.5rem;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n\n.case-study-card:hover {\n  transform: translateY(-10px) scale(1.02);\n  border-color: #cc9900;\n  box-shadow: 0 15px 40px rgba(255, 187, 0, 0.3);\n}\n\n.case-study-category {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: #ffbb00;\n  text-transform: uppercase;\n  letter-spacing: 1.5px;\n  margin-bottom: 1rem;\n  text-shadow: 0 1px 2px rgba(255, 187, 0, 0.2);\n}\n\n.case-study-card h3 {\n  font-size: 2rem;\n  font-weight: 900;\n  margin-bottom: 1rem;\n  color: #000;\n  text-transform: uppercase;\n  letter-spacing: -0.5px;\n  line-height: 1.2;\n}\n\n.case-study-card p {\n  color: #333;\n  line-height: 1.8;\n  margin-bottom: 2rem;\n  font-size: 1.05rem;\n  flex: 1;\n}\n\n.case-study-actions {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n  margin-top: auto;\n}\n\n@media (max-width: 768px) {\n  .case-studies-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .case-study-actions {\n    flex-direction: column;\n  }\n\n  .case-study-actions .btn {\n    width: 100%;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
